import React from 'react';
export function UseCases() {
  return <section className="px-4 md:px-8 py-12 max-w-7xl mx-auto" data-id="element-209">
      <div className="bg-[#F4F5F7] rounded-[3rem] p-8 md:p-16 grid grid-cols-1 md:grid-cols-2 gap-12 relative" data-id="element-210">
        <div className="hidden md:block absolute left-1/2 top-16 bottom-16 w-px bg-gray-200 -translate-x-1/2" data-id="element-211"></div>

        {/* Left Column */}
        <div className="pr-0 md:pr-8" data-id="element-212">
          {/* Style 3 — card heading black */}
          <h2 className="text-card-heading mb-4" data-id="element-213">Casos de uso</h2>
          <p className="text-body !text-gray-600 !text-[16px] !leading-[24px] mb-8" data-id="element-214">
            Valuan es la estructura perfecta para coaches, consultores,
            infoproductores y empresas de servicios que buscan escalar sus
            ventas y automatizar su operación sin complicaciones técnicas.
          </p>
          <div className="flex flex-wrap items-center gap-4" data-id="element-215">
            <a href="#" className="text-[#1F46D5] font-medium hover:underline text-[16px]" data-id="element-216">
              Ver casos de uso →
            </a>
            <a href="https://api.whatsapp.com/send?phone=525511362283&text=Me interesa prueba gratuita de Valuan CRM…" target="_blank" rel="noopener noreferrer" className="text-btn px-6 py-3 rounded-full hover:bg-gray-800 transition-colors bg-[#1F46D5] inline-block text-center" data-id="element-217">
              Actívalo ahora
            </a>
          </div>
        </div>

        {/* Right Column */}
        <div className="pl-0 md:pl-8" data-id="element-218">
          <h2 className="text-card-heading mb-4" data-id="element-219">Negocios y Agencias</h2>
          <p className="text-body !text-gray-600 !text-[16px] !leading-[24px] mb-8" data-id="element-220">
            Potencia el rendimiento de tu equipo centralizando la comunicación y
            los embudos de venta. Valuan te permite gestionar clientes o leads
            simultáneamente, asegurando que ningún cliente se quede sin
            atención.
          </p>
          <div className="flex flex-wrap items-center gap-4" data-id="element-221">
            <a href="#" className="text-[#1F46D5] font-medium hover:underline text-[16px]" data-id="element-222">
              Ver más funciones →
            </a>
            <a href="https://api.whatsapp.com/send?phone=525511362283&text=Vi su sitio web, me interesa Valuan CRM…" target="_blank" rel="noopener noreferrer" className="text-btn px-6 py-3 rounded-full hover:bg-gray-800 transition-colors bg-[#F77630] inline-block text-center" data-id="element-223">
              Contactar Ventas
            </a>
          </div>
        </div>
      </div>
    </section>;
}